import { WRONG_MOVE_HANDLING } from '@/features/sequence-recall/constants';

/**
 * Score calculation utilities for sequence recall offline engine.
 */

/**
 * Calculate final score
 */
export function calculateFinalScore(
  successfulMoves: number,
  scorePerClick: number,
  timeBonus: number,
): number {
  return successfulMoves * scorePerClick + timeBonus;
}

/**
 * Determine if the player is eligible for a time bonus
 */
export function isBonusEligible(
  hasAnyPreviousWrong: boolean,
  wrongMoveHandling: number,
  hasAnySkip = false,
): boolean {
  if (hasAnySkip) {
    return false;
  }
  return (
    wrongMoveHandling === WRONG_MOVE_HANDLING.PLAY_AGAIN ||
    wrongMoveHandling === WRONG_MOVE_HANDLING.PREV_SEQUENCE ||
    !hasAnyPreviousWrong
  );
}

/**
 * Calculate time bonus
 */
export function calculateTimeBonus(
  timeRemainingMs: number,
  bonusTimeRatio: number,
): number {
  if (timeRemainingMs <= 0 || bonusTimeRatio <= 0) return 0;
  const secondsLeft = Math.floor(timeRemainingMs / 1000);
  return Math.floor(secondsLeft * bonusTimeRatio);
}
